<script>
import api from '@/utils/api';

export default {
  data() {
    return {
      loading: false,
      error: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  methods: {
    async fetchCourses() {
      this.loading = true;
      this.error = false;
      try {
        const url = 'courses/';
        const response = await api({ url, method: 'GET' });
        if (response.ok) {
          this.$store.commit('courses', response.body);
        } else {
          this.error = true;
        }
      } catch (e) {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
